import { createStore } from 'vuex'

import Patient from './script/Patient.js'
import Connexion from './script/Connexion.js'
import fisimed from './modules/fisimed'
import flic32 from './modules/flic32'
import SSV from './modules/SSV'
import fonctionsCommunes from './modules/fonctionsCommunes'
import ConnexionStore from '@/modules/ConnexionStore'
import FSEHandler from './modules/FSEHandler.js';
import FormStore from "./modules/FormStore.js";
//import createAuthentificationParCPSModule from '@/modules/AuthentificationParCPS';
import ParametreOptionPraticien from '@/modules/ParametreOptionPraticien';
import Cartes from './modules/Cartes.js';
import Cps from './modules/Cps.js';
import ErreurTransCAM from "@/modules/ErreurTransCAM.js";
import ChoixBenecStore from '@/modules/ChoixBenecStore.js';

//import requestManager from './modules/request.js'

const store = createStore({
    modules: {
        ConnexionStore,
        fisimed,
        flic32,
        SSV,
        fonctionsCommunes,
        //AuthentificationParCPS: createAuthentificationParCPSModule(),
        //LectureCPS: createAuthentificationParCPSModule(),
        Cartes,
        Cps,
        //ConnexionStore,
        FSEHandler,
        FormStore,
        ParametreOptionPraticien,
        ErreurTransCAM,
        ChoixBenecStore,
    },
})



export default store;
